<template>
  <v-container class="pa-0 ma-0" :style="rootContainerStyle">
    <v-btn
      outlined
      dense
      color="secondary"
      class="flex-fill-media"
      @click="compositeDialog = true"
      :height="compositeBtnHeight"
      :width="compositeBtnWidth"
    >
      <v-badge
        v-if="!isMobile && !isTablet"
        :value="recordLength > 0"
        :content="recordLength"
        color="warning"
        overlap
        left
        top
        :class="{ factor: factor, cashier: !factor }"
      ></v-badge>
      <my-icon :name="'composite-icon'" :width="19" :height="19" :cursor-pointer="true" />
      <span class="mr-1" style="color: #000">{{
        typeInv == "recieve" ? $t("compositeReceipt") : $t("compositePayment")
      }}</span>
    </v-btn>

    <!--compositeDialog-->
    <v-dialog
      v-model="compositeDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="650"
      :content-class="isMobile ? 'composite-dialog--mobile' : undefined"
    >
      <!-- Mobile layout -->
      <v-card v-if="isMobile" class="composite-mobile">
        <header class="composite-mobile__header" dir="ltr">
          <button
            type="button"
            class="composite-mobile__icon-btn"
            :aria-label="$t('back')"
            @click="compositeDialog = false"
          >
            <v-icon size="26" color="#37474F">mdi-arrow-left</v-icon>
          </button>
          <h2 class="composite-mobile__title">
            {{
              typeInv == "recieve" ? $t("compositeReceipt") : $t("compositePayment")
            }}
          </h2>
          <span class="composite-mobile__header-spacer" />
        </header>

        <div class="composite-mobile__body" dir="rtl">
          <div class="composite-mobile__top">
            <div class="composite-mobile__customer">
              {{ $t("customer") }}:
              {{ account && account.name ? account.name : $t("haveNot") }}
            </div>

            <div class="composite-mobile__summary">
              <div class="composite-mobile__summary-row">
                <span>{{
                  typeInv == "recieve" ? $t("amountForRecieve") : $t("amountForPay")
                }}</span>
                <strong
                  >{{ $numberFormat(total - credit) }} {{ currency.symbol }}</strong
                >
              </div>
              <div class="composite-mobile__summary-row">
                <span>{{ $t("total-discount") }}</span>
                <strong>{{ $numberFormat(discount) }} {{ currency.symbol }}</strong>
              </div>
              <div class="composite-mobile__summary-row">
                <span>{{ $t("total-tax") }}</span>
                <strong>{{ $numberFormat(totalTax) }} {{ currency.symbol }}</strong>
              </div>
            </div>

            <div class="composite-mobile__section-title">
              {{
                typeInv == "recieve"
                  ? $t("select the recieve option")
                  : $t("select the payment option")
              }}
            </div>
            <div class="composite-mobile__add-grid">
              <button
                type="button"
                class="composite-mobile__add-btn"
                @click="openOptionsDialog('cash-format')"
              >
                <v-icon size="18" color="#5A6B85">mdi-plus</v-icon>
                <span>{{ $t("cash-format") }}</span>
              </button>
              <button
                v-if="pos && typeInv == 'recieve'"
                type="button"
                class="composite-mobile__add-btn"
                @click="openOptionsDialog('pos')"
              >
                <v-icon size="18" color="#5A6B85">mdi-plus</v-icon>
                <span>{{ $t("pos") }}</span>
              </button>
              <button
                type="button"
                class="composite-mobile__add-btn"
                @click="openOptionsDialog('check')"
              >
                <v-icon size="18" color="#5A6B85">mdi-plus</v-icon>
                <span>{{ $t("check") }}</span>
              </button>
              <button
                type="button"
                class="composite-mobile__add-btn"
                @click="openOptionsDialog('bank-deposit')"
              >
                <v-icon size="18" color="#5A6B85">mdi-plus</v-icon>
                <span>{{ $t("bank-deposit") }}</span>
              </button>
            </div>
          </div>

          <div class="composite-mobile__items">
            <div
              v-if="!activeCompositeItems.length"
              class="composite-mobile__empty"
            >
              هنوز آیتمی اضافه نشده است.
            </div>

            <div
              v-for="(item, index) in activeCompositeItems"
              :key="'composite-mobile-' + index + '-' + (item.id || item.amount)"
              class="composite-mobile__card"
            >
              <div class="composite-mobile__card-head">
                <span class="composite-mobile__card-index">{{ index + 1 }}</span>
                <span class="composite-mobile__card-type">
                  {{ $t(item.compositeType) }}
                </span>
                <div class="composite-mobile__card-actions">
                  <button
                    v-if="
                      item.compositeType == 'cash-format' ||
                      item.compositeType == 'check' ||
                      item.compositeType == 'bank-deposit'
                    "
                    type="button"
                    class="composite-mobile__action-btn"
                    :aria-label="$t('edit')"
                    @click="openOptionsDialog(item, 'edit')"
                  >
                    <v-icon size="20" color="#607D8B">mdi-pencil</v-icon>
                  </button>
                  <button
                    type="button"
                    class="composite-mobile__action-btn"
                    :aria-label="$t('remove')"
                    @click="openDeleteDialog(item, compositeItems.indexOf(item))"
                  >
                    <v-icon size="20" color="#E91E63">mdi-delete-outline</v-icon>
                  </button>
                </div>
              </div>
              <div class="composite-mobile__card-row">
                <span>{{ $t("amount") }}</span>
                <strong>
                  {{
                    item.amount != null
                      ? Number(item.amount).toLocaleString("fa-IR")
                      : $t("haveNot")
                  }}
                  {{ currency.symbol }}
                </strong>
              </div>
              <div class="composite-mobile__card-row">
                <span>{{ $t("date") }}</span>
                <strong>{{ compositeItemDate(item) }}</strong>
              </div>
              <div
                v-for="(line, lineIndex) in compositeItemOtherLines(item)"
                :key="'other-' + index + '-' + lineIndex"
                class="composite-mobile__card-row"
              >
                <span>{{ line.label }}</span>
                <strong>{{ line.value }}</strong>
              </div>
            </div>
          </div>
        </div>

        <div class="composite-mobile__footer" dir="rtl">
          <div class="composite-mobile__totals">
            <div class="composite-mobile__totals-row">
              <span>{{
                typeInv == "recieve" ? $t("total-recieve") : $t("total-payments")
              }}</span>
              <strong
                >{{ totalAmount.toLocaleString("fa-IR") }}
                {{ currency.symbol }}</strong
              >
            </div>
            <div
              class="composite-mobile__totals-row"
              :class="{ 'is-error': invoiceRemain < 0 }"
            >
              <span>{{ $t("invoice-remain") }}</span>
              <strong
                >{{ $numberFormat(invoiceRemain) }} {{ currency.symbol }}</strong
              >
            </div>
          </div>
          <v-btn
            color="primary"
            block
            depressed
            height="48"
            @click="confirmTable"
          >
            {{ $t("confirm") }}
          </v-btn>
        </div>
      </v-card>

      <!-- Desktop layout -->
      <v-card v-else class="pa-5">
        <v-container
          class="pa-0 d-flex justify-space-between mb-5"
        >
          <v-card-text class="text-h5 pa-0">{{
            typeInv == "recieve" ? $t("compositeReceipt") : $t("compositePayment")
          }}</v-card-text>
          <v-icon @click="compositeDialog = false">mdi-close</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-2">
          {{ $t("customer") }} :
          {{ account && account.name ? account.name : $t("haveNot") }}
        </v-card-text>
        <v-container
          class="pa-0 d-flex align-center wrapper-total mt-2"
        >
          <v-container class="item d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-caption">{{
              typeInv == "recieve" ? $t("amountForRecieve") : $t("amountForPay")
            }}</v-card-text>
            <v-card-text class="pa-0 text-caption text-disable secondary--text"
              >{{ $numberFormat(total - credit) }} {{ currency.symbol }}</v-card-text
            >
          </v-container>
          <v-container class="item d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-caption">{{
              $t("total-discount")
            }}</v-card-text>
            <v-card-text class="pa-0 text-caption text-disable secondary--text"
              >{{ $numberFormat(discount) }} {{ currency.symbol }}</v-card-text
            >
          </v-container>
          <v-container class="item d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-caption">{{ $t("total-tax") }}</v-card-text>
            <v-card-text class="pa-0 text-caption text-disable secondary--text"
              >{{ $numberFormat(totalTax) }} {{ currency.symbol }}</v-card-text
            >
          </v-container>
        </v-container>
        <v-container
          class="pa-0 d-flex justify-space-between align-center my-3"
        >
          <v-card-text class="pa-0 text-body-2">{{
            typeInv == "recieve"
              ? $t("select the recieve option")
              : $t("select the payment option")
          }}</v-card-text>
          <v-container class="pa-0 d-flex align-center gap-1 ma-0" style="width: auto">
            <v-btn
              color="secondary"
              outlined
              custom
              style="height: 32px !important; font-size: 8pt !important"
              @click="openOptionsDialog('cash-format')"
            >
              {{ $t("cash-format") }}
              <v-icon size="16" class="mr-1">mdi-plus</v-icon>
            </v-btn>
            <v-btn
              v-if="pos && typeInv == 'recieve'"
              color="secondary"
              outlined
              custom
              style="height: 32px !important; font-size: 8pt !important"
              @click="openOptionsDialog('pos')"
            >
              {{ $t("pos") }}
              <v-icon size="16" class="mr-1">mdi-plus</v-icon>
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              custom
              style="height: 32px !important; font-size: 8pt !important"
              @click="openOptionsDialog('check')"
            >
              {{ $t("check") }}
              <v-icon size="16" class="mr-1">mdi-plus</v-icon>
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              custom
              style="height: 32px !important; font-size: 8pt !important"
              @click="openOptionsDialog('bank-deposit')"
            >
              {{ $t("bank-deposit") }}
              <v-icon size="16" class="mr-1">mdi-plus</v-icon>
            </v-btn>
          </v-container>
        </v-container>
        <v-data-table
          :headers="compositeTableHeaders"
          :items="compositeItems"
          :items-per-page="-1"
          hide-default-footer
          height="265"
          fixed-header
          class="composite"
          :item-class="getRowClass"
        >
          <template v-slot:item.row="{ item, index }">
            <v-card-text v-if="item.row != null" class="pa-0 text-caption">
              {{ item.row }}
            </v-card-text>
            <v-card-text v-if="item.row == null" class="pa-0 text-caption">
              {{ index + 1 }}
            </v-card-text>
          </template>
          <template v-slot:item.type="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ $t(item.compositeType) }}
            </v-card-text>
          </template>
          <template v-slot:item.date="{ item }">
            <v-card-text
              v-if="item.date != null && item.dueDate == null"
              class="pa-0 text-caption"
            >
              {{ item.date }}
            </v-card-text>
            <v-card-text
              v-if="item.date == null && item.dueDate != null"
              class="pa-0 text-caption"
            >
              {{ item.dueDate }}
            </v-card-text>
            <v-card-text
              v-if="item.date != null && item.dueDate != null"
              class="pa-0 text-caption"
            >
              {{ item.dueDate }}
            </v-card-text>
            <v-card-text
              v-if="item.date == null && item.dueDate == null"
              class="pa-0 text-caption text-disable secondary--text"
            >
              {{ $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.amount="{ item }">
            <v-card-text v-if="item.amount != null" class="pa-0 text-caption">
              {{ Number(item.amount).toLocaleString("fa-IR") }} {{ currency.symbol }}
            </v-card-text>
            <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">
              {{ $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.other="{ item }">
            <v-card-text v-if="item.other != null" class="pa-0 text-caption">
              <div v-if="item.other.bank != null" class="my-1">
                <span>{{ $t("bank") }} : </span>
                <span>{{ item.other.bank.name }}</span>
              </div>
              <div
                v-if="item.other.bank == null && item.other.bankName != null"
                class="my-1"
              >
                <span>{{ $t("bank") }} : </span>
                <span>{{ item.other.bankName.name }}</span>
              </div>
              <div v-if="item.other.paymentByPos != null" class="my-1">
                <span>{{ $t("pos") }} : </span>
                <span>{{ item.other.paymentByPos }}</span>
              </div>
              <div v-if="item.other.fishermanNumber != null" class="my-1">
                <span>{{ $t("fishermanNumber") }} : </span>
                <span>{{ item.other.fishermanNumber }}</span>
              </div>
              <div v-if="item.other.number != null" class="my-1">
                <span>{{ $t("check-number") }} : </span>
                <span>{{ item.other.number }}</span>
              </div>
              <div v-if="item.other.transferOption != null" class="my-1">
                <span>{{ $t("transfer-type") }} : </span>
                <span>{{ $t(item.other.transferOption) }}</span>
              </div>
            </v-card-text>
            <v-card-text v-else-if="item.other == null" class="pa-0 text-caption">
              <div v-if="item.bank != null && item.bankName == null" class="my-1">
                <span>{{ $t("bank") }} : </span>
                <span>{{ item.bank.name }}</span>
              </div>
              <div v-if="item.bank == null && item.bankName != null" class="my-1">
                <span>{{ $t("bank") }} : </span>
                <span>{{ item.bankName.name }}</span>
              </div>
              <div v-if="item.bank != null && item.bankName != null" class="my-1">
                <span>{{ $t("bank") }} : </span>
                <span>{{ item.bankName.name }}</span>
              </div>
              <div v-if="item.paymentByPos != null" class="my-1">
                <span>{{ $t("pos") }} : </span>
                <span>{{ $t(item.paymentByPos) }}</span>
              </div>
              <div v-if="item.fishermanNumber != null" class="my-1">
                <span>{{ $t("fishermanNumber") }} : </span>
                <span>{{ item.fishermanNumber }}</span>
              </div>
              <div v-if="item.number != null" class="my-1">
                <span>{{ $t("check-number") }} : </span>
                <span>{{ item.number }}</span>
              </div>
              <div v-if="item.transferOption != null" class="my-1">
                <span>{{ $t("transfer-type") }} : </span>
                <span>{{ $t(item.transferOption) }}</span>
              </div>
            </v-card-text>
            <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">
              {{ $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:header.edit="{ header }">
            <v-container class="pa-0 d-flex align-center ma-0 gap-3">
              {{ header.text }}
              <div @click="openDeleteDialog" style="cursor: pointer">
                <my-icon
                  :name="'trash-icon'"
                  :width="15"
                  :height="15"
                  :cursor-pointer="true"
                />
              </div>
            </v-container>
          </template>
          <template v-slot:item.edit="{ item, index }">
            <v-container class="pa-0 d-flex align-center ma-0 justify-space-between">
              <div
                @click="openOptionsDialog(item, 'edit')"
                style="cursor: pointer"
                class="pr-2"
                v-if="
                  item.compositeType == 'cash-format' ||
                  item.compositeType == 'check' ||
                  item.compositeType == 'bank-deposit'
                "
              >
                <my-icon
                  :name="'plus-icon'"
                  :width="15"
                  :height="15"
                  :cursor-pointer="true"
                />
              </div>
              <div @click="openDeleteDialog(item, index)" style="cursor: pointer">
                <my-icon
                  :name="'trash-icon'"
                  :width="15"
                  :height="15"
                  :cursor-pointer="true"
                />
              </div>
            </v-container>
          </template>
          <!--<template
            v-slot:body.append
          >
            <tr>
              <td colspan="6"></td>
            </tr>
            <tr>
              <td colspan="2" style="width: 120px;border-left: 1px solid silver;">
                  <v-card-text class="pa-0 text-caption my-2">{{ $t('total-payments') }}</v-card-text>
                  <v-card-text
                    class="pa-0 text-caption mb-2"
                    :class="{ 'error--text': invoiceRemain < 0 }"
                  >
                    {{ $t('invoice-remain') }}
                  </v-card-text>
              </td>
              <td colspan="2" style="width: 228px;border-left: 1px solid silver;">
                  <v-card-text class="pa-0 text-caption my-2 pl-9 d-flex justify-end">{{ totalAmount.toLocaleString('fa-IR') }} {{ userInfo?.init?.currency?.name }}</v-card-text>
                  <v-card-text
                    class="pa-0 text-caption mb-2 pl-9 d-flex justify-end"
                    :class="{ 'error--text': invoiceRemain < 0 }"
                  >
                    {{ $numberFormat(invoiceRemain) }} {{ userInfo?.init?.currency?.name }}
                  </v-card-text>
              </td>
              <td colspan="1"></td>
              <td colspan="1"></td>
            </tr>
          </template>-->
          <!--<template v-slot:footer.prepend>
            <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0"
            style="margin-top: -10px"
            >
            <v-text-field
                v-model.number="page"
                :label="$t('goToPage')"
                min="1"
                :max="pageCount"
                type="number"
                outlined
                height="32"
                hide-details
                hide-spin-buttons
                dense
                :suffix="'  /  ' + pageCount"
            />
            </v-col>
        </template>-->
        </v-data-table>
        <v-container class="pa-0 d-flex justify-space-between mt-3">
          <div class="d-flex align-center gap-1">
            <v-btn dense color="primary" height="32" @click="confirmTable">
              {{ $t("confirm") }}
            </v-btn>
            <!--<v-btn
              dense
              outlined
              color="secondary"
              height="32"
              @click="cancelTable"
            >
            {{ $t('cancel') }}
            </v-btn>-->
          </div>
          <v-card class="pa-3 table-overview" width="250px">
            <div class="d-flex justify-space-between gap-8 mb-2">
              <v-card-text class="pa-0 text-caption">{{
                typeInv == "recieve" ? $t("total-recieve") : $t("total-payments")
              }}</v-card-text>
              <v-card-text class="pa-0 text-caption"
                >{{ totalAmount.toLocaleString("fa-IR") }}
                {{ currency.symbol }}</v-card-text
              >
            </div>
            <div class="d-flex justify-space-between gap-8">
              <v-card-text
                class="pa-0 text-caption"
                :class="{ 'error--text': invoiceRemain < 0 }"
                >{{ $t("invoice-remain") }}</v-card-text
              >
              <v-card-text
                class="pa-0 text-caption"
                :class="{ 'error--text': invoiceRemain < 0 }"
                >{{ $numberFormat(invoiceRemain) }} {{ currency.symbol }}</v-card-text
              >
            </div>
          </v-card>
        </v-container>
      </v-card>
    </v-dialog>

    <!--cash + pos + check + bankDeposit (dialog)-->
    <v-dialog
      v-model="optionsDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="720"
      :content-class="isMobile ? 'composite-options-dialog--mobile' : undefined"
    >
      <v-card :class="isMobile ? 'composite-mobile composite-mobile--options' : 'pa-5'">
        <header v-if="isMobile" class="composite-mobile__header" dir="ltr">
          <button
            type="button"
            class="composite-mobile__icon-btn"
            :aria-label="$t('back')"
            @click="optionsDialog = false"
          >
            <v-icon size="26" color="#37474F">mdi-arrow-left</v-icon>
          </button>
          <h2 class="composite-mobile__title">{{ resolveMultiPaymentTitle() }}</h2>
          <span class="composite-mobile__header-spacer" />
        </header>
        <v-container
          v-else
          class="pa-0 d-flex justify-space-between mb-5"
        >
          <v-card-text class="text-h5 pa-0">
            {{ resolveMultiPaymentTitle() }}
          </v-card-text>
          <v-icon @click="optionsDialog = false" size="25">mdi-close</v-icon>
        </v-container>

        <div :class="isMobile ? 'composite-mobile__body' : ''" dir="rtl">
          <div
            v-if="isMobile"
            class="composite-mobile__summary composite-mobile__summary--compact"
          >
            <div class="composite-mobile__summary-row">
              <span>{{ $t("customer") }}</span>
              <strong>{{
                account && account.name
                  ? account.name
                  : account && account.firstname
                  ? account.firstname + " " + (account.lastname || "")
                  : $t("haveNot")
              }}</strong>
            </div>
            <div class="composite-mobile__summary-row">
              <span>{{
                typeInv == "recieve" ? $t("amountForRecieve") : $t("amountForPay")
              }}</span>
              <strong
                >{{ $numberFormat(total - credit) }} {{ currency.symbol }}</strong
              >
            </div>
            <div
              class="composite-mobile__summary-row"
              :class="{ 'is-error': invoiceRemain < 0 }"
            >
              <span>{{ $t("remain") }}</span>
              <strong
                >{{ $numberFormat(invoiceRemain) }} {{ currency.symbol }}</strong
              >
            </div>
          </div>

          <v-row
            :style="isMobile ? null : { gap: '4rem' }"
            :class="isMobile ? 'ma-0' : 'mb-8'"
          >
            <v-col cols="12" :md="isMobile ? 12 : 7" :class="{ 'px-0': isMobile }">
              <v-form ref="form" v-model="valid">
                <v-card-text class="pa-0 text-body-2 mb-5">{{
                  typeInv == "recieve" ? $t("recieveSetting") : $t("paymentSetting")
                }}</v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <money
                      v-model="newRecord.amount"
                      :label="$t('amount')"
                      :dense="true"
                      :outlined="true"
                      :rules="[feeValidate]"
                      :solo="false"
                      :clearable="true"
                      class="mb-3 dense"
                      value-when-is-empty=""
                      :options="options"
                      :disabled="isCustomerCheck"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <autocomplete
                      v-if="
                        typeInv == 'pay' &&
                        typeInv != 'recieve' &&
                        optionsFormat == 'check'
                      "
                      v-model="newRecord.check"
                      :rules="[(v) => !!v || $t('is-required')]"
                      :title="$t('check')"
                      type="payCheck"
                      :value="newRecord.check"
                      @input="selectCheck"
                      @clear="clearCheck"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="optionsFormat == 'pos'" class="mt-1">
                  <v-col cols="12" md="12">
                    <v-card-text class="pa-0 text-body-2 mb-3 mt-1">{{
                      $t("select-pos")
                    }}</v-card-text>
                    <v-container class="pa-0 pos-wrapper ma-0">
                      <v-btn custom color="primary" v-if="isPosAvailable">
                        {{ $t(selectedPos) }}
                      </v-btn>
                    </v-container>
                  </v-col>
                </v-row>
                <v-card-text
                  v-if="optionsFormat == 'check'"
                  class="pa-0 text-body-2 mt-5"
                  >{{ $t("check-information") }}</v-card-text
                >
                <v-card-text
                  v-if="optionsFormat == 'bank-deposit'"
                  class="pa-0 text-body-2 mt-5"
                  >{{ $t("transfer-type") }}</v-card-text
                >
                <v-container
                  v-if="optionsFormat == 'bank-deposit'"
                  class="pa-0 transfer-wrapper ma-0 mt-3"
                  :class="{ 'transfer-wrapper--mobile': isMobile }"
                >
                  <div
                    v-for="(item, index) in transferOptions"
                    :key="index"
                    class="flex-fill pa-2 d-flex justify-center transfer-option"
                    :class="{
                      'transfer-option--active':
                        selectedTransferOption == item.value,
                    }"
                    @click="selectTransformOption(item)"
                  >
                    <v-card-text class="pa-0 text-caption">
                      {{ item.label }}
                    </v-card-text>
                  </div>
                </v-container>
                <v-row
                  v-if="
                    optionsFormat == 'cash-format' ||
                    optionsFormat == 'check' ||
                    optionsFormat == 'bank-deposit'
                  "
                  class="mt-3"
                >
                  <v-col cols="12" md="6">
                    <autocomplete
                      v-if="
                        optionsFormat == 'cash-format' ||
                        optionsFormat == 'bank-deposit'
                      "
                      :title="$t('bank-or-fund')"
                      append-icon="mdi-chevron-down"
                      clear-icon="mdi-close"
                      outlined
                      dense
                      clearable
                      v-model="newRecord.bank"
                      :rules="[(v) => !!v || $t('is-required')]"
                      item-text="name"
                      return-object
                      type="bankCash"
                      :value="newRecord.bank"
                      :currency-prop="currency.id"
                    />
                    <autocomplete
                      v-if="optionsFormat == 'check' && typeInv == 'pay'"
                      :title="$t('bank')"
                      append-icon="mdi-chevron-down"
                      clear-icon="mdi-close"
                      outlined
                      dense
                      clearable
                      v-model="newRecord.bankName"
                      item-text="name"
                      return-object
                      :disabled="isCustomerCheck || !!newRecord.check"
                      type="getBankList"
                      :value="newRecord.bankName"
                      :currency-prop="currency.id"
                    />
                    <autocomplete
                      v-if="optionsFormat == 'check' && typeInv == 'recieve'"
                      :title="$t('bank')"
                      append-icon="mdi-chevron-down"
                      clear-icon="mdi-close"
                      outlined
                      dense
                      clearable
                      v-model="newRecord.bankName"
                      item-text="name"
                      return-object
                      type="getBankList"
                      :value="newRecord.bankName"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <template
                      v-if="
                        optionsFormat == 'cash-format' ||
                        optionsFormat == 'bank-deposit'
                      "
                    >
                      <v-text-field
                        id="cashPaymentDate"
                        v-model="newRecord.date"
                        :label="$t('date')"
                        append-icon="mdi-calendar"
                        :rules="[(v) => !!v || $t('is-required')]"
                        outlined
                        dense
                        clearable
                      />
                      <date-picker
                        v-model="newRecord.date"
                        element="cashPaymentDate"
                        :locale="$store.state.date_locale"
                        :format="$store.state.date_format"
                        auto-submit
                        :min="$store.state.startDate"
                        :max="$store.state.endDate"
                        :color="
                          this.$vuetify.theme.themes[
                            this.$vuetify.theme.isDark ? 'dark' : 'light'
                          ].primary
                        "
                        @close="setDate"
                      />
                    </template>
                    <template v-if="optionsFormat == 'check'">
                      <v-text-field
                        id="cashPaymentDate"
                        v-model="newRecord.dueDate"
                        :label="$t('date-of-receipt')"
                        append-icon="mdi-calendar"
                        :rules="[(v) => !!v || $t('is-required')]"
                        outlined
                        dense
                        clearable
                        :disabled="isCustomerCheck"
                      />
                      <date-picker
                        v-model="newRecord.dueDate"
                        element="cashPaymentDate"
                        :locale="$store.state.date_locale"
                        :format="$store.state.date_format"
                        auto-submit
                        :min="$store.state.startDate"
                        :color="
                          this.$vuetify.theme.themes[
                            this.$vuetify.theme.isDark ? 'dark' : 'light'
                          ].primary
                        "
                        @close="setDate"
                        :disabled="isCustomerCheck"
                      />
                    </template>
                  </v-col>
                  <v-col cols="12" md="6" class="mt-3" v-if="optionsFormat == 'check'">
                    <v-text-field
                      v-model="newRecord.number"
                      :label="$t('check-number')"
                      outlined
                      dense
                      clearable
                      :rules="[(v) => !!v || $t('is-required')]"
                      :disabled="isCustomerCheck || !!newRecord.check"
                    />
                  </v-col>
                  <v-col cols="12" md="6" class="mt-3" v-if="optionsFormat == 'check'">
                    <v-text-field
                      v-model="newRecord.fishermanNumber"
                      :label="$t('fishermanNumber')"
                      outlined
                      dense
                      clearable
                      :disabled="isCustomerCheck"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
            <v-col v-if="!isMobile" cols="12" md="4">
              <v-container class="pa-0 ma-0">
                <v-card-text class="pa-0 text-body-2 mb-4">{{
                  $t("invoice-information")
                }}</v-card-text>
                <v-container class="pa-0 d-flex align-center gap-1">
                  <img
                    src="@/assets/imagePlacholder.png"
                    style="width: 25px; border-radius: 4px; border: 1px solid silver"
                  />
                  <v-card-text
                    class="pa-0 text-body-2"
                    v-if="
                      account != null &&
                      account.firstname != null &&
                      account.lastname != null
                    "
                    >{{ $t("customer") }} :
                    {{ account.firstname + " " + account.lastname }}</v-card-text
                  >
                  <v-card-text class="pa-0 text-caption secondary--text" v-else
                    >{{ $t("customer") }} : {{ $t("haveNot") }}</v-card-text
                  >
                </v-container>
                <v-container class="pa-2 mt-2 amounts-wrapper">
                  <div class="d-flex justify-space-between">
                    <v-card-text class="pa-0 text-caption">{{
                      $t("total-tax")
                    }}</v-card-text>
                    <v-card-text class="pa-0 text-caption"
                      >{{ $numberFormat(totalTax) }} {{ currency.symbol }}</v-card-text
                    >
                  </div>
                  <div class="d-flex justify-space-between">
                    <v-card-text class="pa-0 text-caption">{{
                      $t("total-discount")
                    }}</v-card-text>
                    <v-card-text class="pa-0 text-caption"
                      >{{ $numberFormat(discount) }} {{ currency.symbol }}</v-card-text
                    >
                  </div>
                  <div class="d-flex justify-space-between">
                    <v-card-text class="pa-0 text-caption">{{
                      typeInv == "recieve" ? $t("amountForRecieve") : $t("amountForPay")
                    }}</v-card-text>
                    <v-card-text class="pa-0 text-caption"
                      >{{ $numberFormat(total - credit) }}
                      {{ currency.symbol }}</v-card-text
                    >
                  </div>
                  <div class="d-flex justify-space-between">
                    <v-card-text class="pa-0 text-caption">{{
                      typeInv == "recieve" ? $t("total-recieve") : $t("total-payments")
                    }}</v-card-text>
                    <v-card-text class="pa-0 text-caption"
                      >{{ totalAmount.toLocaleString("fa-IR") }}
                      {{ currency.symbol }}</v-card-text
                    >
                  </div>
                  <div class="d-flex justify-space-between">
                    <v-card-text
                      class="pa-0 text-caption"
                      style="color: #0066ff"
                      :class="{ 'error--text': invoiceRemain < 0 }"
                    >
                      {{ $t("remain") }}
                    </v-card-text>
                    <v-card-text
                      class="pa-0 text-caption"
                      style="color: #0066ff"
                      :class="{ 'error--text': invoiceRemain < 0 }"
                    >
                      {{ $numberFormat(invoiceRemain) }} {{ currency.symbol }}
                    </v-card-text>
                  </div>
                </v-container>
              </v-container>
            </v-col>
          </v-row>
        </div>

        <div
          v-if="isMobile"
          class="composite-mobile__footer composite-mobile__footer--actions"
          dir="rtl"
        >
          <v-btn
            v-if="optionsFormat == 'pos' && optionsDialogType != 'edit'"
            color="primary"
            block
            depressed
            height="48"
            :loading="loading"
            @click="sendToPosWithConfirm"
          >
            {{ $t("visit-pos") }}
          </v-btn>
          <v-btn
            v-else
            color="primary"
            block
            depressed
            height="48"
            @click="checkValidation"
          >
            {{ optionsDialogType == "edit" ? $t("edit") : $t("confirm") }}
          </v-btn>
          <v-btn
            outlined
            block
            color="secondary"
            height="44"
            @click="optionsDialog = false"
          >
            {{ $t("cancel") }}
          </v-btn>
        </div>
        <v-container v-else class="pa-0 d-flex align-center gap-1">
          <v-btn
            v-if="optionsFormat == 'pos' && optionsDialogType != 'edit'"
            dense
            color="primary"
            height="32"
            @click="sendToPosWithConfirm"
            :loading="loading"
          >
            {{ $t("visit-pos") }}
          </v-btn>
          <v-btn v-else dense color="primary" height="32" @click="checkValidation">
            {{ optionsDialogType == "edit" ? $t("edit") : $t("confirm") }}
          </v-btn>
          <v-btn
            dense
            outlined
            color="secondary"
            height="32"
            @click="optionsDialog = false"
          >
            {{ $t("cancel") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>

    <!--delete dialog (desktop UI unchanged)-->
    <v-dialog
      v-if="!isMobile"
      v-model="deleteDialog"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-card-text class="pa-0 text-body-2" v-if="!isAllItemsDeleting">{{
          $t("Are you sure you want to delete this item ?")
        }}</v-card-text>
        <v-card-text class="pa-0 text-body-2" v-if="isAllItemsDeleting">{{
          $t("are you sure you want to delete all items?")
        }}</v-card-text>
        <div v-if="!isAllItemsDeleting">
          <v-container
            v-if="deletedItem.type"
            class="pa-0 d-flex align-center gap-1 mt-2"
          >
            <v-card-text class="pa-0 text-body-2">{{ $t("type") }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{
              $t(deletedItem.type)
            }}</v-card-text>
          </v-container>
          <v-container
            v-if="deletedItem.date != null && deletedItem.dueDate == null"
            class="pa-0 d-flex align-center gap-1 mt-2"
          >
            <v-card-text class="pa-0 text-body-2">{{ $t("date") }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{ deletedItem.date }}</v-card-text>
          </v-container>
          <v-container
            v-if="deletedItem.date == null && deletedItem.dueDate != null"
            class="pa-0 d-flex align-center gap-1 mt-2"
          >
            <v-card-text class="pa-0 text-body-2">{{ $t("date") }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{ deletedItem.dueDate }}</v-card-text>
          </v-container>
          <v-container
            v-if="deletedItem.date != null && deletedItem.dueDate != null"
            class="pa-0 d-flex align-center gap-1 mt-2"
          >
            <v-card-text class="pa-0 text-body-2">{{ $t("date") }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{ deletedItem.dueDate }}</v-card-text>
          </v-container>
          <v-container
            v-if="deletedItem.amount"
            class="pa-0 d-flex align-center gap-1 mt-2"
          >
            <v-card-text class="pa-0 text-body-2">{{ $t("amount") }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{
              Number(deletedItem.amount).toLocaleString("fa-IR")
            }}</v-card-text>
          </v-container>
          <v-container
            v-if="deletedItem.bank"
            class="pa-0 d-flex align-center gap-1 mt-2"
          >
            <v-card-text class="pa-0 text-body-2">{{ $t("bank") }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{ deletedItem.bank }}</v-card-text>
          </v-container>
          <v-container v-if="deletedItem.pos" class="pa-0 d-flex align-center gap-1 mt-2">
            <v-card-text class="pa-0 text-body-2">{{ $t("pos") }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{ deletedItem.pos }}</v-card-text>
          </v-container>
          <v-container
            v-if="deletedItem.fishermanNumber"
            class="pa-0 d-flex align-center gap-1 mt-2"
          >
            <v-card-text class="pa-0 text-body-2"
              >{{ $t("fishermanNumber") }} :
            </v-card-text>
            <v-card-text class="pa-0 text-caption">{{
              deletedItem.fishermanNumber
            }}</v-card-text>
          </v-container>
          <v-container
            v-if="deletedItem.checkNumber"
            class="pa-0 d-flex align-center gap-1 mt-2"
          >
            <v-card-text class="pa-0 text-body-2"
              >{{ $t("check-number") }} :
            </v-card-text>
            <v-card-text class="pa-0 text-caption">{{
              deletedItem.checkNumber
            }}</v-card-text>
          </v-container>
          <v-container
            v-if="deletedItem.transferOption"
            class="pa-0 d-flex align-center gap-1 mt-2"
          >
            <v-card-text class="pa-0 text-body-2"
              >{{ $t("transfer-type") }} :
            </v-card-text>
            <v-card-text class="pa-0 text-caption">{{
              $t(deletedItem.transferOption)
            }}</v-card-text>
          </v-container>
        </div>
        <v-container class="pa-0 d-flex align-center gap-1 mt-7">
          <v-btn color="error" height="32" @click="deleteItem">
            {{ $t("yes") }}
          </v-btn>
          <v-btn outlined height="32" color="secondary" @click="deleteDialog = false">
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Mobile-only delete confirm sheet; same deleteItem / close logic -->
    <v-bottom-sheet v-if="isMobile" v-model="deleteDialog">
      <v-card class="composite-confirm-sheet" dir="rtl">
        <div class="composite-confirm-sheet__handle" />
        <div class="composite-confirm-sheet__title">
          {{ $t("delete") }}
        </div>
        <p class="composite-confirm-sheet__subtitle">
          {{
            isAllItemsDeleting
              ? $t("are you sure you want to delete all items?")
              : $t("Are you sure you want to delete this item ?")
          }}
        </p>
        <div v-if="!isAllItemsDeleting" class="composite-confirm-sheet__rows">
          <div v-if="deletedItem.type" class="composite-confirm-sheet__row">
            <span>{{ $t("type") }}</span>
            <strong>{{ $t(deletedItem.type) }}</strong>
          </div>
          <div
            v-if="deletedItem.date != null && deletedItem.dueDate == null"
            class="composite-confirm-sheet__row"
          >
            <span>{{ $t("date") }}</span>
            <strong>{{ deletedItem.date }}</strong>
          </div>
          <div
            v-if="deletedItem.date == null && deletedItem.dueDate != null"
            class="composite-confirm-sheet__row"
          >
            <span>{{ $t("date") }}</span>
            <strong>{{ deletedItem.dueDate }}</strong>
          </div>
          <div
            v-if="deletedItem.date != null && deletedItem.dueDate != null"
            class="composite-confirm-sheet__row"
          >
            <span>{{ $t("date") }}</span>
            <strong>{{ deletedItem.dueDate }}</strong>
          </div>
          <div v-if="deletedItem.amount" class="composite-confirm-sheet__row">
            <span>{{ $t("amount") }}</span>
            <strong class="is-ltr">{{
              Number(deletedItem.amount).toLocaleString("fa-IR")
            }}</strong>
          </div>
          <div v-if="deletedItem.bank" class="composite-confirm-sheet__row">
            <span>{{ $t("bank") }}</span>
            <strong>{{ deletedItem.bank }}</strong>
          </div>
          <div v-if="deletedItem.pos" class="composite-confirm-sheet__row">
            <span>{{ $t("pos") }}</span>
            <strong>{{ deletedItem.pos }}</strong>
          </div>
          <div
            v-if="deletedItem.fishermanNumber"
            class="composite-confirm-sheet__row"
          >
            <span>{{ $t("fishermanNumber") }}</span>
            <strong>{{ deletedItem.fishermanNumber }}</strong>
          </div>
          <div
            v-if="deletedItem.checkNumber"
            class="composite-confirm-sheet__row"
          >
            <span>{{ $t("check-number") }}</span>
            <strong>{{ deletedItem.checkNumber }}</strong>
          </div>
          <div
            v-if="deletedItem.transferOption"
            class="composite-confirm-sheet__row"
          >
            <span>{{ $t("transfer-type") }}</span>
            <strong>{{ $t(deletedItem.transferOption) }}</strong>
          </div>
        </div>
        <div class="composite-confirm-sheet__actions">
          <v-btn
            color="error"
            block
            depressed
            height="48"
            class="composite-confirm-sheet__yes"
            @click="deleteItem"
          >
            {{ $t("yes") }}
          </v-btn>
          <v-btn
            outlined
            block
            height="48"
            color="secondary"
            class="composite-confirm-sheet__no"
            @click="deleteDialog = false"
          >
            {{ $t("no") }}
          </v-btn>
        </div>
      </v-card>
    </v-bottom-sheet>

    <!--check remain dialog (desktop UI unchanged)-->
    <v-dialog
      v-if="!isMobile"
      v-model="checkRemainDialog"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-card-text class="pa-0 text-body-2">{{
          $t("Are you sure you want to pay more than remain ?")
        }}</v-card-text>
        <v-container class="pa-0 d-flex align-center gap-1 mt-7">
          <v-btn color="error" height="32" @click="confirmRemain">
            {{ $t("yes") }}
          </v-btn>
          <v-btn
            outlined
            height="32"
            color="secondary"
            @click="checkRemainDialog = false"
          >
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Mobile-only confirm sheet; same confirmRemain / close logic -->
    <v-bottom-sheet v-if="isMobile" v-model="checkRemainDialog">
      <v-card class="composite-confirm-sheet" dir="rtl">
        <div class="composite-confirm-sheet__handle" />
        <div class="composite-confirm-sheet__title">
          {{ $t("confirm") }}
        </div>
        <p class="composite-confirm-sheet__subtitle">
          {{ $t("Are you sure you want to pay more than remain ?") }}
        </p>
        <div class="composite-confirm-sheet__rows">
          <div class="composite-confirm-sheet__row">
            <span>{{ $t("invoice-remain") }}</span>
            <strong class="is-ltr"
              >{{ $numberFormat(invoiceRemain) }}
              {{ currency && currency.symbol }}</strong
            >
          </div>
          <div class="composite-confirm-sheet__row">
            <span>{{ $t("amount") }}</span>
            <strong class="is-ltr"
              >{{ $numberFormat(newRecord.amount) }}
              {{ currency && currency.symbol }}</strong
            >
          </div>
        </div>
        <div class="composite-confirm-sheet__actions">
          <v-btn
            color="error"
            block
            depressed
            height="48"
            class="composite-confirm-sheet__yes"
            @click="confirmRemain"
          >
            {{ $t("yes") }}
          </v-btn>
          <v-btn
            outlined
            block
            height="48"
            color="secondary"
            class="composite-confirm-sheet__no"
            @click="checkRemainDialog = false"
          >
            {{ $t("no") }}
          </v-btn>
        </div>
      </v-card>
    </v-bottom-sheet>

    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import General from "@/Mixins/general.js";
import moment from "moment-jalaali";
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";

export default {
  name: "InvoiceIndex",
  props: {
    totalTax: [Number, String],
    discount: [Number, String],
    total: String,
    credit: [Number, String],
    account: Object,
    optionDialogType: String,
    propType: String,
    propDate: String,
    isInvoiceCreated: Boolean,
    editCompositeTableData: Array,
    currency: Object,
    pos: Boolean,
    factor: Boolean,
    returnPosInfo: Object,
    isPosSuccessfull: Boolean,
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    compositeDialog: false,
    compositeTableHeaders: [],
    compositeItems: [],
    newRecord: {
      id: null,
      type: null,
      amount: null,
      bank: null,
      date: null,
      paymentByPos: null,
      fishermanNumber: null,
      number: null,
      dueDate: null,
      account: null,
      bankAccountNumber: null,
      cashBox: null,
      bankName: null,
      check: null,
      kind: null,
      given: null,
      content: null,
      branch: null,
      transferOption: null,
      compositeType: null,
      status: "active",
    },
    valid: true,
    bankItems: [],
    optionsDialog: false,
    optionsFormat: null,
    optionsDialogType: null,
    items: [],
    posOptions: [],
    selectedPos: null,
    selectedTransferOption: null,
    editedIndex: null,
    deleteDialog: false,
    deletedIndex: null,
    deletedItem: {
      type: null,
      date: null,
      amount: null,
      bank: null,
      pos: null,
      fishermanNumber: null,
      checkNumber: null,
      transferOption: null,
    },
    isAllItemsDeleting: false,
    options: {
      locale: "en-US",
      prefix: "",
      suffix: "  ",
      precision: 0,
    },
    userInfo: null,
    banksNameItems: [],
    checkRemainDialog: false,
    isCustomerCheck: false,
    snakbar: false,
    snakbarText: null,
    isPosAvailable: false,
    loading: false,
    typeInv: null,
    recordLength: 0,
  }),
  mixins: [General],
  components: {
    MyIcon,
  },
  computed: {
    rootContainerStyle() {
      if (this.compact) {
        return "width: 100% !important; height: 100%; display: flex;";
      }
      return "width: auto !important";
    },
    compositeBtnHeight() {
      if (this.compact) {
        return undefined;
      }
      if (this.$vuetify.breakpoint.width <= 1137) {
        return 40;
      }
      if (this.pos && !this.factor) {
        return this.resolveHeightBtn();
      }
      return 55;
    },
    compositeBtnWidth() {
      if (this.compact) {
        return undefined;
      }
      if (this.$vuetify.breakpoint.width <= 1137) {
        return 100;
      }
      if (this.pos && !this.factor) {
        return 120;
      }
      return 138;
    },
    transferOptions() {
      return [
        { label: this.$t("cardToCard"), value: "cardToCard" },
        { label: this.$t("accountToAccount"), value: "accountToAccount" },
        { label: this.$t("ibanTransfer"), value: "ibanTransfer" },
        { label: this.$t("satnaTransfer"), value: "satnaTransfer" },
        { label: this.$t("payaTransfer"), value: "payaTransfer" },
        { label: this.$t("plTransfer"), value: "plTransfer" },
      ];
    },
    // total payment
    totalAmount() {
      return this.compositeItems.reduce((sum, item) => {
        // Calculate only if the status is not "deactive"
        if (item.status !== "deactive") {
          sum += Number(item.amount) || 0;
        }
        return sum;
      }, 0);
    },
    /*     totalAmount () {
        return this.compositeItems.reduce((sum, item) => {
          return sum + (Number(item.amount) || 0) // Ensure it's a number
        }, 0)
      }, */
    // remain
    invoiceRemain() {
      const totalValue = Number(this.total) || 0;
      const totalAmountValue = Number(this.totalAmount) || 0;
      return Number(totalValue) - this.credit - Number(totalAmountValue);
    },
    activeCompositeItems() {
      return (this.compositeItems || []).filter(
        (item) => item && item.status !== "deactive"
      );
    },
    /*     computedBanks () {
        if (this.isCustomerCheck) {
          return this.newRecord.bankName ? [this.newRecord.bankName] : []
        }
        return this.banksNameItems
      } */
  },
  /* activated: function () {
      this.beforeMount()
    }, */
  beforeMount() {
    this.compositeTableHeaders = [
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 25,
      },
      {
        text: this.$t("type"),
        align: "start",
        sortable: false,
        value: "type",
      },
      {
        text: this.$t("date"),
        align: "start",
        sortable: false,
        value: "date",
      },
      {
        text: this.$t("amount"),
        align: "start",
        sortable: false,
        value: "amount",
      },
      {
        text: this.$t("other"),
        align: "start",
        sortable: false,
        value: "other",
      },
      {
        text: this.$t("edit"),
        align: "start",
        sortable: false,
        value: "edit",
      },
    ];
  },
  methods: {
    /*     selectPos (item) {
      this.selectedPos = item.value
      this.newRecord.paymentByPos = item.label
    }, */
    selectTransformOption(item) {
      this.selectedTransferOption = item.value;
      this.newRecord.transferOption = item.value;
    },
    resolveHeightBtn() {
      if (this.restaurantPermission) {
        return 47;
      } else {
        return 50;
      }
    },
    checkValidation() {
      if (this.$refs.form.validate() && this.editedIndex == null) {
        if (this.newRecord.amount > this.invoiceRemain) {
          this.checkRemainDialog = true;
        } else {
          this.addNewRecord();
        }
      }
      if (this.$refs.form.validate() && this.editedIndex != null) {
        if (this.newRecord.amount > this.invoiceRemain) {
          this.checkRemainDialog = true;
        } else {
          this.editRecord();
        }
      }
    },
    addNewRecord() {
      this.newRecord.compositeType = this.optionsFormat;
      // add to table
      this.compositeItems.push(this.newRecord);
      if (
        this.optionsFormat == "cash-format" ||
        this.optionsFormat === "bank-deposit" ||
        this.optionsFormat == "pos"
      ) {
        this.newRecord.dueDate = null;
        this.newRecord.bankName = null;
      }
      if (this.optionsFormat == "check") {
        this.newRecord.date = null;
        this.newRecord.bank = null;
      }
      // push to an array
      this.items.push({
        ...this.newRecord,
        type: this.optionsFormat === "check" ? this.typeInv + "Check" : this.typeInv,
      });

      /* console.log(JSON.stringify(this.items)) */
      // emit that array
      this.$emit("update", this.items);
      // reset keys
      this.newRecord = {
        id: null,
        type: this.optionsFormat === "check" ? this.typeInv + "Check" : this.typeInv,
        /* amount: null, */
        bank: null,
        date: null,
        paymentByPos: null,
        fishermanNumber: null,
        number: null,
        dueDate: null,
        account: null,
        bankAccountNumber: null,
        cashBox: null,
        bankName: null,
        check: null,
        kind: null,
        given: null,
        content: null,
        branch: null,
        transferOption: null,
        compositeType: null,
        status: "active",
      };
      // reset form
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      this.selectedPos = null;
      this.selectedTransferOption = null;
      // close the dialog
      this.optionsDialog = false;

      if (this.pos) {
        this.$emit("successAdded");
      }
    },
    editRecord() {
      this.newRecord.compositeType = this.optionsFormat;
      // edit table
      this.compositeItems.splice(this.editedIndex, 1, this.newRecord);
      if (this.optionsFormat == "cash-format" || this.optionsFormat === "bank-deposit") {
        this.newRecord.dueDate = null;
        this.newRecord.bankName = null;
      }
      if (this.optionsFormat == "check") {
        this.newRecord.date = null;
        this.newRecord.bank = null;
      }
      if (this.$route.path.includes("edit")) {
        this.items.splice(this.editedIndex, 1, {
          id: this.items[this.editedIndex].id,
          status: this.items[this.editedIndex].status,
          account: this.items[this.editedIndex].account,
          amount: this.newRecord.amount,
          bank: this.newRecord.bank,
          bankAccountNumber: this.items[this.editedIndex].bankAccountNumber,
          bankName: this.newRecord.bankName,
          branch: this.items[this.editedIndex].branch,
          cashBox: this.items[this.editedIndex].cashBox,
          check: this.newRecord.check,
          compositeType: this.items[this.editedIndex].compositeType,
          content: this.items[this.editedIndex].content,
          date: this.newRecord.date,
          dueDate: this.newRecord.dueDate,
          fishermanNumber: this.newRecord.fishermanNumber,
          given: this.items[this.editedIndex].given,
          kind: this.items[this.editedIndex].kind,
          number: this.newRecord.number,
          paymentByPos: this.newRecord.paymentByPos,
          transferOption: this.newRecord.transferOption,
          type: this.items[this.editedIndex].type,
        });
      } else {
        this.items.splice(this.editedIndex, 1, {
          ...this.newRecord,
          type: this.optionsFormat === "check" ? this.typeInv + "Check" : this.typeInv,
        });
      }
      this.editedIndex = null;
      this.$emit("update", this.items);
      this.optionsDialog = false;
    },
    openOptionsDialog(value, type) {
      this.optionsDialog = true;
      if (type == null) {
        this.optionsFormat = value;
        this.newRecord.amount = this.invoiceRemain;
        this.newRecord.compositeType = this.optionsFormat;
        this.newRecord.date = this.propDate;
        this.newRecord.dueDate = this.propDate;
        if (this.optionsFormat == "bank-deposit") {
          this.selectedTransferOption = this.transferOptions[0].value;
          this.newRecord.transferOption = this.transferOptions[0].value;
        }
        if (this.optionsFormat == "pos") {
          var m = moment();
          if (this.$store.state.date_locale === "fa,en") {
            const shamsiYear = m.jYear();
            const shamsiMonth = m.jMonth() + 1;
            const shamsiDay = m.jDate();
            this.today = `${shamsiDay}/${shamsiMonth}/${shamsiYear}`;
            const reversedDate = this.today.split("/").reverse().join("/");
            this.newRecord.date = reversedDate;
          }

          const posDevice = JSON.parse(localStorage.getItem("posDevice"));
          if (
            posDevice != undefined &&
            Array.isArray(posDevice) &&
            posDevice.length > 0
          ) {
            this.isPosAvailable = true;
            const preSelect = posDevice.find((item) => item.status == "active");
            this.selectedPos = preSelect.posDevice.Key;
            this.newRecord.paymentByPos = preSelect.posDevice.Key;
            this.newRecord.bank = preSelect.bank;
          } else {
            this.snakbar = true;
            this.snakbarText = this.$t("first in setting below set your pos device.");
            this.snakbarColor = "red";
          }
        }
        if (this.optionsFormat == "cash-format") {
          this.newRecord.bank = JSON.parse(localStorage.getItem("selectedBank"));
        }
      }
      if (type === "edit") {
        this.optionsFormat = value.compositeType;
        this.newRecord.compositeType = this.optionsFormat;
        this.optionsDialogType = type;
        const selectedRecord = value;
        if (this.$route.path.includes("edit")) {
          this.editedIndex = this.items.findIndex(
            (item) => item.id === selectedRecord.id
          );
        } else {
          this.editedIndex = this.items.findIndex(
            (item) =>
              item.amount === selectedRecord.amount &&
              (item.date != null
                ? item.date === selectedRecord.date
                : item.dueDate === selectedRecord.dueDate)
          );
        }
        this.newRecord = {
          id: selectedRecord.id,
          type: this.optionsFormat === "check" ? this.typeInv + "Check" : this.typeInv,
          amount: selectedRecord.amount,
          bank: selectedRecord.bank,
          date: selectedRecord.date,
          paymentByPos: selectedRecord.paymentByPos,
          fishermanNumber: selectedRecord.fishermanNumber,
          number: selectedRecord.number,
          dueDate: selectedRecord.dueDate,
          account: null,
          bankAccountNumber: null,
          cashBox: null,
          bankName: selectedRecord.bankName,
          check: selectedRecord.check,
          kind: null,
          given: null,
          content: null,
          branch: null,
          transferOption: selectedRecord.transferOption,
          compositeType: selectedRecord.compositeType,
          status: "active",
        };
        this.selectedPos = selectedRecord.paymentByPos;
        this.selectedTransferOption = selectedRecord.transferOption;
      }
    },
    resolveMultiPaymentTitle() {
      if (this.optionsFormat == "cash-format") {
        if (this.optionsDialogType == "edit") {
          return this.typeInv == "recieve"
            ? this.$t("edit-cash-recieve")
            : this.$t("edit-cash-payment");
        }
        return this.typeInv == "recieve"
          ? this.$t("new-cash-recieve")
          : this.$t("new-cash-payment");
      }
      if (this.optionsFormat == "pos") {
        if (this.optionsDialogType == "edit") {
          return this.$t("edit-pos-payment");
        }
        return this.$t("new-pos-payment");
      }
      if (this.optionsFormat == "check") {
        if (this.optionsDialogType == "edit") {
          return this.$t("edit-check");
        }
        return this.$t("check");
      }
      if (this.optionsFormat == "bank-deposit") {
        if (this.optionsDialogType == "edit") {
          return this.$t("edit-bank-deposit");
        }
        return this.$t("new-bank-deposit");
      }
    },
    openDeleteDialog(item, index) {
      this.deleteDialog = true;
      if (item != null && index != null) {
        this.deletedIndex = index;
        this.deletedItem.type = item.type;
        this.deletedItem.date = item.date;
        this.deletedItem.dueDate = item.dueDate;
        this.deletedItem.amount = item.amount;
        this.deletedItem.bank = item.bank
          ? item.bank.name
          : item.bankName
          ? item.bankName.name
          : item.bankName && item.bank
          ? item.bank.name
          : null;
        this.deletedItem.pos = item.paymentByPos;
        this.deletedItem.fishermanNumber = item.fishermanNumber;
        this.deletedItem.checkNumber = item.number;
        this.deletedItem.transferOption = item.transferOption;
      } else {
        this.isAllItemsDeleting = true;
      }
    },
    deleteItem() {
      if (!this.isAllItemsDeleting) {
        if (this.compositeItems[this.deletedIndex]) {
          this.compositeItems[this.deletedIndex].status = "deactive";
        }
        /*         const activeItems = this.compositeItems.filter(item => item.status == 'active')
          this.compositeItems = [...activeItems] */
        // this.compositeItems.splice(this.deletedIndex, 1)
        this.compositeItems.forEach((item, index) => {
          item.row = index + 1; // Adjust row to be the index + 1
        });
        // this.items.splice(this.deletedIndex, 1)
        if (this.items[this.deletedIndex]) {
          this.items[this.deletedIndex].status = "deactive";
        }
      } else {
        this.compositeItems.forEach((item) => (item.status = "deactive"));
        // this.items = []
        this.items.forEach((item) => (item.status = "deactive"));
      }

      this.deleteDialog = false;

      this.$emit("update", this.items);
    },
    fetchBanks() {
      var app = this;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            select: "bankCash",
          },
        })
        .then((r) => {
          this.bankItems = r.data.data;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
    fetchBanksName() {
      var app = this;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            select: "getBankList",
          },
        })
        .then((r) => {
          this.banksNameItems = r.data.data;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
    confirmRemain() {
      this.checkRemainDialog = false;
      if (this.editedIndex == null) {
        this.addNewRecord();
      }
      if (this.editedIndex != null) {
        this.editRecord();
      }
    },
    confirmTable() {
      this.compositeDialog = false;
    },
    /*     cancelTable () {
        this.compositeDialog = false
        this.compositeItems = []
      }, */
    selectCheck(select) {
      if (select) {
        if (select.type == "customer") {
          this.isCustomerCheck = true;
        }
        this.newRecord.amount = select.amount ? select.amount : this.newRecord.amount;
        this.newRecord.fishermanNumber = select.fisherman_number
          ? select.fisherman_number
          : this.newRecord.fishermanNumber;
        this.newRecord.number = select.number ? select.number : this.newRecord.number;
        this.newRecord.bankName = select.bank_name
          ? { name: select.bank_name }
          : select.bank
          ? select.bank
          : this.newRecord.bankName;
        //edit name bank from own and customer
        this.newRecord.dueDate = select.due_date
          ? select.due_date
          : this.newRecord.dueDate;
      }
    },
    clearCheck() {
      this.isCustomerCheck = false;
      this.newRecord.amount = null;
      this.newRecord.fishermanNumber = null;
      this.newRecord.number = null;
      this.newRecord.bankName = null;
      this.newRecord.dueDate = null;
      this.$refs.form.reset();
    },
    getRowClass(item) {
      return item.status === "deactive" ? "d-none" : "";
    },
    compositeItemDate(item) {
      if (!item) return this.$t("haveNot");
      if (item.dueDate) return item.dueDate;
      if (item.date) return item.date;
      return this.$t("haveNot");
    },
    compositeItemOtherLines(item) {
      if (!item) return [];
      const lines = [];
      const other = item.other || {};
      const bank =
        (item.bank && item.bank.name) ||
        (item.bankName && item.bankName.name) ||
        (other.bank && other.bank.name) ||
        (other.bankName && other.bankName.name);
      if (bank) {
        lines.push({ label: this.$t("bank"), value: bank });
      }
      const pos = item.paymentByPos || other.paymentByPos;
      if (pos) {
        lines.push({
          label: this.$t("pos"),
          value: typeof pos === "string" ? this.$t(pos) : pos,
        });
      }
      const fishermanNumber = item.fishermanNumber || other.fishermanNumber;
      if (fishermanNumber) {
        lines.push({ label: this.$t("fishermanNumber"), value: fishermanNumber });
      }
      const number = item.number || other.number;
      if (number) {
        lines.push({ label: this.$t("check-number"), value: number });
      }
      const transferOption = item.transferOption || other.transferOption;
      if (transferOption) {
        lines.push({
          label: this.$t("transfer-type"),
          value: this.$t(transferOption),
        });
      }
      return lines;
    },
    sendToPosWithConfirm() {
      if (this.newRecord.amount != undefined && this.newRecord.amount != null) {
        this.$emit("sendToPosProcess", this.newRecord.amount);
      }
      if (this.isPosSuccessfull) {
        this.optionsDialog = false;
        this.checkValidation();
      }
    },
  },
  created() {
    const bank = localStorage.getItem("selectedBank");
    if (bank) {
      try {
        this.newRecord.bank = JSON.parse(bank);
      } catch (e) {
        console.error("Failed to parse bank from storage", e);
      }
    }
  },
  mounted() {
    // const storedData = localStorage.getItem('compositeItems')
    /* if (storedData) {
        this.compositeItems = JSON.parse(storedData)
      } */

    this.userInfo = JSON.parse(localStorage.getItem("token"));
    this.fetchBanks();
    this.fetchBanksName();
    this.newRecord.type =
      this.optionsFormat === "check" ? this.typeInv + "Check" : this.typeInv;
    this.newRecord.date = this.propDate;
    this.newRecord.dueDate = this.propDate;
    /* if (this.transferOptions.length > 0) {
        this.selectedTransferOption = this.transferOptions[0].value
        this.newRecord.transferOption = this.transferOptions[0].label
      } */
  },
  watch: {
    "newRecord.bank": function (val) {
      if (val) {
        localStorage.setItem("selectedBank", JSON.stringify(val));
      }
    },
    optionsDialog(val) {
      if (val) {
        this.$emit("paymentDialogOpen");
        return;
      }
      // reset keys
      this.newRecord = {
        id: null,
        type: null,
        /* amount: null, */
        bank: null,
        date: this.propDate,
        paymentByPos: null,
        fishermanNumber: null,
        number: null,
        dueDate: null,
        account: null,
        bankAccountNumber: null,
        cashBox: null,
        bankName: null,
        check: null,
        kind: null,
        given: null,
        content: null,
        branch: null,
        transferOption: null,
        compositeType: null,
        status: "active",
      };
      // reset form
      this.$refs.form.reset();
      this.selectedPos = null;
      this.selectedTransferOption = null;
      // reset text
      this.optionsDialogType = null;
      this.optionsFormat = null;
      this.editedIndex = null;
      this.isCustomerCheck = false;
      this.$emit("closeOptionsDialog");
    },
    compositeDialog(val) {
      if (val) this.$emit("paymentDialogOpen");
    },
    deleteDialog(val) {
      if (val) {
        this.$emit("paymentDialogOpen");
        return;
      }
      this.deletedIndex = null;
      this.isAllItemsDeleting = false;
    },
    checkRemainDialog(val) {
      if (val) this.$emit("paymentDialogOpen");
    },
    /*     invoiceRemain (val) {
        this.newRecord.amount = val
        this.$emit('invoiceRemain', val)
      }, */
    invoiceRemain: {
      immediate: true, // Emit immediately when component is created
      handler(val) {
        this.newRecord.amount = val;
        this.$emit("invoiceRemain", val);
      },
    },
    optionDialogType(val) {
      if (val === "cash-format") {
        this.openOptionsDialog("cash-format");
      }
      if (val === "pos") {
        const posDevice = JSON.parse(localStorage.getItem("posDevice"));
        if (posDevice != undefined && Array.isArray(posDevice) && posDevice.length > 0) {
          const preSelect = posDevice.find((item) => item.status == "active");

          this.newRecord = {
            id: null,
            type: this.typeInv,
            amount: this.returnPosInfo.amount,
            bank: preSelect.bank,
            date: this.returnPosInfo.date,
            paymentByPos: preSelect.posDevice.Key,
            fishermanNumber: null,
            number: null,
            dueDate: null,
            account: null,
            bankAccountNumber: null,
            cashBox: null,
            bankName: null,
            check: null,
            kind: null,
            given: null,
            content: null,
            branch: null,
            transferOption: null,
            compositeType: "pos",
            status: "active",
          };
          this.optionsFormat = "pos";
          this.addNewRecord();
          this.compositeDialog = false;
        }
      }
    },
    totalAmount(val) {
      this.$emit("totalAmount", val);
    },
    isInvoiceCreated(val) {
      if (val) {
        this.compositeItems = [];
      }
    },
    editCompositeTableData: {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          /*           const activeItems = newValue.filter(item => item.status == 'active')
            this.compositeItems = [...activeItems] */
          this.compositeItems = [...newValue];
          this.items = [...newValue];
        } else {
          this.compositeItems = [];
          this.items = [];
        }
      },
      immediate: true,
      deep: true,
    },
    account(val) {
      /* console.log(JSON.stringify(val)) */
    },
    propType: {
      handler(newValue) {
        if (newValue) {
          this.typeInv = newValue;
        }
      },
      immediate: true,
      deep: true,
    },
    items: {
      handler(val) {
        if (val) {
          this.recordLength = val.filter((rec) => rec.status == "active").length;
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
::v-deep .v-badge.cashier .v-badge__badge {
  top: -30px !important;
  right: -19px !important;
  font-size: 13px;
  height: 21px;
  min-width: 21px;
  max-width: 21px;
}
::v-deep .v-badge.factor .v-badge__badge {
  top: -32px !important;
  right: -29px !important;
  font-size: 13px;
  height: 21px;
  min-width: 21px;
  max-width: 21px;
}
.v-application .overflow-y-auto {
  overflow-y: unset !important;
}
.wrapper-total {
  border: 1px solid silver;
  border-radius: 4px;
}
.wrapper-total .item {
  border-left: 1px solid silver;
  padding: 5px !important;
}
.v-card__text {
  width: auto;
}
::v-deep .v-data-table.composite .v-data-table-header {
  background-color: #d9d9d9;
}
::v-deep .v-data-table.composite {
  border: 1px solid silver;
  /*  border-bottom: 0;
   border-bottom-right-radius: 0;
   border-bottom-left-radius: 0; */
  /* height: 300px;
  overflow-y: auto; */
}
::v-deep .v-data-table.composite .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::v-deep .v-data-table.composite .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}
::v-deep .v-data-table.composite .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
/* ::v-deep .v-data-table.composite > .v-data-table__wrapper > table {
  height: 100%;
} */
::v-deep .v-data-table.composite > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 8.3pt;
  border-left: 1px solid silver;
  padding: 0 9px;
  color: black;
  height: 40px !important;
  /* background-color: #eeeeee; */
}
::v-deep
  .v-data-table.composite
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:first-child {
  border-top-right-radius: 4px;
}
::v-deep
  .v-data-table.composite
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:last-child {
  padding: 0 8px 0 4px;
  width: 30px;
  border-left: none;
  border-top-left-radius: 4px;
}
::v-deep .v-data-table.composite > .v-data-table__wrapper > table > tbody {
  position: relative;
}
::v-deep .v-data-table.composite > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid silver;
  padding-right: 10px;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr:first-child:hover
  td:first-child {
  border-top-left-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:last-child {
  border-top-right-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:last-child {
  border-top: 1px solid silver;
  background-color: #f6f6f6;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:nth-last-child(2) {
  background-color: #f6f6f6;
}
::v-deep
  .v-data-table.composite
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  width: 0;
  border-left: none;
  padding: 0 8px 0 3.6pt;
}
::v-deep .v-input__icon.v-input__icon--append .v-icon {
  font-size: 15px;
}
.amounts-wrapper {
  border-radius: 4px;
  border: 1px solid silver;
  display: flex;
  flex-direction: column;
  row-gap: 0.3rem;
}
.pos-wrapper {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 0.3rem;
}
.transfer-wrapper {
  border: 1px solid silver;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
.transfer-wrapper > div {
  border-left: 1px solid silver;
  cursor: pointer;
}
.transfer-wrapper > div:last-child {
  border-left: 0 !important;
}
.transfer-option--active {
  background-color: #5a6b85 !important;
  border-color: #5a6b85 !important;
  color: #fff !important;
}
.transfer-option--active .v-card__text {
  color: #fff !important;
}
.table-overview {
  box-shadow: none !important;
  background-color: #f6f6f6;
}
.v-card__text {
  width: auto;
}

.composite-mobile {
  --cm-bg: #f7f8fa;
  --cm-surface: #ffffff;
  --cm-surface-soft: #eef2f6;
  --cm-border: #d7dee6;
  --cm-border-soft: #e6ebf0;
  --cm-text: #37474f;
  --cm-muted: #78909c;
  --cm-accent: #5a6b85;
  --cm-accent-soft: #e8edf5;
  --cm-radius: 12px;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  min-height: 100%;
  background: var(--cm-bg) !important;
  border-radius: 0 !important;
  color: var(--cm-text);
  overflow: hidden;
}

.composite-mobile__header {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: 44px 1fr 44px;
  align-items: center;
  gap: 4px;
  min-height: 56px;
  padding: 8px 10px;
  background: var(--cm-surface);
  border-bottom: 1px solid var(--cm-border-soft);
}

.composite-mobile__title {
  margin: 0;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: var(--cm-text);
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.composite-mobile__header-spacer {
  width: 40px;
  height: 40px;
}

.composite-mobile__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background: transparent;
  cursor: pointer;
}

.composite-mobile__icon-btn:active {
  background: var(--cm-surface-soft);
}

.composite-mobile__body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 14px 14px 0;
}

.composite-mobile__top {
  flex: 0 0 auto;
}

.composite-mobile__items {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 12px;
}

.composite-mobile__customer {
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
  color: var(--cm-muted);
}

.composite-mobile__summary {
  margin-bottom: 14px;
  padding: 12px 14px;
  border: 1px solid var(--cm-border-soft);
  border-radius: var(--cm-radius);
  background: var(--cm-surface-soft);
}

.composite-mobile__summary--compact {
  margin-bottom: 16px;
}

.composite-mobile__summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 5px 0;
  font-size: 13px;
  color: var(--cm-muted);
}

.composite-mobile__summary-row strong {
  font-size: 13px;
  font-weight: 700;
  color: var(--cm-text);
}

.composite-mobile__summary-row.is-error,
.composite-mobile__summary-row.is-error strong,
.composite-mobile__totals-row.is-error,
.composite-mobile__totals-row.is-error strong {
  color: #e53935;
}

.composite-mobile__section-title {
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 700;
  color: var(--cm-accent);
}

.composite-mobile__add-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 14px;
}

.composite-mobile__add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 44px;
  padding: 0 10px;
  border: 1px solid #c5d0e0;
  border-radius: var(--cm-radius);
  background: var(--cm-accent-soft);
  color: var(--cm-accent);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.composite-mobile__add-btn:last-child:nth-child(odd) {
  grid-column: 1 / -1;
}

.composite-mobile__add-btn:active {
  background: #dce4f0;
}

.composite-mobile__empty {
  padding: 18px 12px;
  border: 1px dashed #c5ced6;
  border-radius: var(--cm-radius);
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: #90a4ae;
  background: var(--cm-surface-soft);
}

.composite-mobile__card {
  margin-bottom: 10px;
  padding: 12px 14px;
  border: 1px solid var(--cm-border-soft);
  border-radius: var(--cm-radius);
  background: var(--cm-surface);
  box-shadow: 0 1px 2px rgba(55, 71, 79, 0.04);
}

.composite-mobile__card:last-child {
  margin-bottom: 0;
}

.composite-mobile__card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.composite-mobile__card-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  border-radius: 8px;
  background: var(--cm-surface-soft);
  color: var(--cm-accent);
  font-size: 12px;
  font-weight: 700;
}

.composite-mobile__card-type {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 14px;
  font-weight: 700;
  color: var(--cm-text);
}

.composite-mobile__card-actions {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.composite-mobile__action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background: transparent;
  cursor: pointer;
}

.composite-mobile__action-btn:active {
  background: var(--cm-surface-soft);
}

.composite-mobile__card-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 3px 0;
  font-size: 12px;
  color: var(--cm-muted);
}

.composite-mobile__card-row strong {
  font-size: 12px;
  font-weight: 700;
  color: var(--cm-text);
  text-align: left;
}

.composite-mobile__footer {
  flex: 0 0 auto;
  position: relative;
  z-index: 3;
  padding: 12px 14px calc(12px + env(safe-area-inset-bottom));
  background: var(--cm-surface);
  border-top: 1px solid var(--cm-border-soft);
  box-shadow: 0 -8px 18px rgba(247, 248, 250, 0.9);
}

.composite-mobile__footer--actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.composite-mobile__footer--actions ::v-deep .v-btn {
  border-radius: 12px !important;
  letter-spacing: 0 !important;
  font-weight: 700 !important;
  text-transform: none !important;
}

.composite-mobile__footer--actions ::v-deep .v-btn.primary {
  box-shadow: none !important;
  background-color: var(--cm-accent) !important;
  border-color: var(--cm-accent) !important;
}

.composite-mobile__footer--actions ::v-deep .v-btn--outlined {
  background: var(--cm-surface-soft) !important;
  border-color: var(--cm-border) !important;
  color: var(--cm-accent) !important;
}

.composite-mobile__totals {
  margin-bottom: 10px;
  padding: 10px 12px;
  border-radius: var(--cm-radius);
  border: 1px solid var(--cm-border-soft);
  background: var(--cm-surface-soft);
}

.composite-mobile__totals-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 3px 0;
  font-size: 13px;
  color: var(--cm-muted);
}

.composite-mobile__totals-row strong {
  font-size: 13px;
  font-weight: 700;
  color: var(--cm-text);
}

.composite-mobile--options .composite-mobile__body {
  padding-bottom: 8px;
}

.composite-mobile--options ::v-deep .text-body-2 {
  color: var(--cm-accent) !important;
  font-weight: 700 !important;
  font-size: 13px !important;
  margin-bottom: 10px !important;
}

.composite-mobile--options ::v-deep .v-input {
  margin: 0 0 12px !important;
  padding: 0 !important;
  border-radius: var(--cm-radius);
}

.composite-mobile--options ::v-deep .v-input__control,
.composite-mobile--options ::v-deep .v-input__slot {
  min-height: 44px !important;
  margin: 0 !important;
}

.composite-mobile--options ::v-deep .v-text-field--outlined fieldset,
.composite-mobile--options ::v-deep .v-input--is-focused fieldset {
  border-color: var(--cm-border) !important;
  border-width: 1px !important;
  border-radius: var(--cm-radius) !important;
}

.composite-mobile--options ::v-deep .v-text-field--outlined .v-input__slot,
.composite-mobile--options ::v-deep .v-select--outlined .v-input__slot,
.composite-mobile--options ::v-deep .v-autocomplete--outlined .v-input__slot {
  background: var(--cm-surface) !important;
  border-radius: var(--cm-radius) !important;
  min-height: 44px !important;
}

.composite-mobile--options ::v-deep .v-text-field--outlined.v-input--is-focused fieldset,
.composite-mobile--options ::v-deep .v-select--outlined.v-input--is-focused fieldset,
.composite-mobile--options ::v-deep .v-autocomplete--outlined.v-input--is-focused fieldset {
  border-color: #90a4ae !important;
}

.composite-mobile--options ::v-deep .v-label {
  color: var(--cm-muted) !important;
  font-size: 13px !important;
}

.composite-mobile--options ::v-deep input,
.composite-mobile--options ::v-deep .v-select__selection {
  color: var(--cm-text) !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}

.composite-mobile--options ::v-deep .v-icon {
  color: #90a4ae !important;
}

.composite-mobile--options ::v-deep .v-messages {
  min-height: 0 !important;
}

.composite-mobile--options ::v-deep .col,
.composite-mobile--options ::v-deep .v-col {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.transfer-wrapper--mobile {
  flex-wrap: wrap;
  border: 1px solid var(--cm-border-soft) !important;
  border-radius: var(--cm-radius) !important;
  overflow: hidden;
  background: var(--cm-surface);
}

.transfer-wrapper--mobile > div {
  flex: 1 1 calc(50% - 1px);
  min-width: calc(50% - 1px);
  border-bottom: 1px solid var(--cm-border-soft);
  border-left: 1px solid var(--cm-border-soft) !important;
  background: var(--cm-surface);
  color: var(--cm-text);
}

.transfer-wrapper--mobile > div:nth-child(even) {
  border-left: 0 !important;
}

.transfer-wrapper--mobile > div:nth-last-child(-n + 2) {
  border-bottom: 0;
}

.transfer-wrapper--mobile .transfer-option--active {
  background-color: var(--cm-accent) !important;
  border-color: var(--cm-accent) !important;
  color: #fff !important;
}

.composite-confirm-sheet {
  border-radius: 20px 20px 0 0 !important;
  padding: 8px 16px 16px;
  background: #fff !important;
}

.composite-confirm-sheet__handle {
  width: 40px;
  height: 4px;
  margin: 4px auto 14px;
  border-radius: 999px;
  background: #cfd8dc;
}

.composite-confirm-sheet__title {
  text-align: center;
  font-size: 18px;
  font-weight: 800;
  color: #212121;
  margin: 0 0 8px;
}

.composite-confirm-sheet__subtitle {
  margin: 0 0 16px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: #607d8b;
  line-height: 1.6;
}

.composite-confirm-sheet__rows {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 18px;
}

.composite-confirm-sheet__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 48px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #f5f7f9;
  font-size: 13px;
  font-weight: 600;
  color: #607d8b;
}

.composite-confirm-sheet__row strong {
  font-size: 14px;
  font-weight: 800;
  color: #263238;
  text-align: left;
}

.composite-confirm-sheet__row strong.is-ltr {
  direction: ltr;
}

.composite-confirm-sheet__actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.composite-confirm-sheet__yes {
  border-radius: 12px !important;
  font-weight: 800 !important;
  letter-spacing: 0 !important;
}

.composite-confirm-sheet__no {
  border-radius: 12px !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
}
</style>

<style>
/* Mobile-only: keep desktop max-width (650/720) untouched */
.v-dialog.composite-dialog--mobile,
.v-dialog.composite-options-dialog--mobile {
  margin: 0 !important;
  height: 100% !important;
  max-height: 100% !important;
  width: 100% !important;
  max-width: 100% !important;
}
</style>
